/* Visions From Neptune — small behaviours for vfn-* sections. */
(function () {
  if (window.__vfnLoaded) return;
  window.__vfnLoaded = true;

  /* Keep --vfn-hero-h in step with the header height, for sections that run behind it */
  const trackHero = () => {
    const heroes = document.querySelectorAll('[data-vfn-hero]');
    const hero = heroes[heroes.length - 1];
    if (!hero) return;
    const set = () => document.documentElement.style.setProperty('--vfn-hero-h', hero.offsetHeight + 'px');
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(hero); else window.addEventListener('resize', set);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trackHero); else trackHero();

  /* Mobile menu */
  if (!customElements.get('vfn-nav')) {
    customElements.define('vfn-nav', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('.vfn-nav__toggle');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const open = this.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open);
        });
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) { this.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { this.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
        });
      }
    });
  }

  /* Sideways photo scroller: swipe, drag, arrows, optional slow drift */
  if (!customElements.get('vfn-scroller')) {
    customElements.define('vfn-scroller', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.vfn-scroller__track');
        this.prev = this.querySelector('[data-vfn-prev]');
        this.next = this.querySelector('[data-vfn-next]');
        if (!this.track) return;

        const step = () => Math.max(this.track.clientWidth * 0.7, 240);
        this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        this.next && this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        window.addEventListener('resize', () => this.updateArrows());
        this.updateArrows();

        /* Mouse drag (touch already scrolls natively) */
        let startX = 0, startLeft = 0, dragging = false, moved = false;
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse') return;
          dragging = true; moved = false; startX = e.clientX; startLeft = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(e.pointerId);
        });
        this.track.addEventListener('pointermove', (e) => {
          if (!dragging) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 4) moved = true;
          this.track.scrollLeft = startLeft - dx;
        });
        const end = () => { dragging = false; this.track.classList.remove('is-dragging'); };
        this.track.addEventListener('pointerup', end);
        this.track.addEventListener('pointercancel', end);
        this.track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

        /* Optional slow drift */
        if (this.dataset.autoscroll === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          let paused = false;
          const pause = () => (paused = true), resume = () => (paused = false);
          this.addEventListener('pointerenter', pause); this.addEventListener('pointerleave', resume);
          this.addEventListener('touchstart', pause, { passive: true });
          this.addEventListener('focusin', pause); this.addEventListener('focusout', resume);
          const speed = parseFloat(this.dataset.speed || '0.4');
          let pos = this.track.scrollLeft;
          const tick = () => {
            if (!paused && !dragging) {
              const max = this.track.scrollWidth - this.track.clientWidth;
              pos = Math.abs(pos - this.track.scrollLeft) > 2 ? this.track.scrollLeft : pos;
              pos += speed;
              if (pos >= max) pos = 0;
              this.track.scrollLeft = pos;
            } else {
              pos = this.track.scrollLeft;
            }
            requestAnimationFrame(tick);
          };
          this.track.style.scrollSnapType = 'none';
          requestAnimationFrame(tick);
        }
      }
      updateArrows() {
        if (!this.prev || !this.next) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max;
      }
    });
  }

  /* ---------- Pop-out cart ---------- */
  const R = () => window.vfnRoutes || { cartAdd: '/cart/add.js', cart: '/cart.js', cartChange: '/cart/change.js', cartPage: '/cart', checkout: '/checkout' };
  const api = window.vfnCartApi || {
    get: () => fetch(R().cart, { headers: { Accept: 'application/json' } }).then(r => r.json()),
    add: (id, quantity) => fetch(R().cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity }] }) })
      .then(async r => { const j = await r.json(); if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add that to your cart.'); return j; }),
    change: (key, quantity) => fetch(R().cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) })
      .then(async r => { const j = await r.json(); if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not update your cart.'); return j; })
  };
  let drawer, listEl, totalEl, msgEl, checkoutBtn, busy = false;
  const money = (cents, cur) => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); } };
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function build() {
    if (drawer) return;
    drawer = document.createElement('dialog');
    drawer.className = 'vfn vfn-cart';
    drawer.setAttribute('aria-labelledby', 'VfnCartTitle');
    drawer.innerHTML = `
      <div class="vfn-cart__panel">
        <div class="vfn-cart__head">
          <h2 class="vfn-cart__title" id="VfnCartTitle">Your cart</h2>
          <button type="button" class="vfn-cart__close" aria-label="Close cart">&times;</button>
        </div>
        <p class="vfn-cart__msg" role="status" aria-live="polite"></p>
        <ul class="vfn-cart__list" role="list"></ul>
        <div class="vfn-cart__foot">
          <div class="vfn-cart__total"><span>Total</span><strong></strong></div>
          <p class="vfn-cart__note">Taxes and discounts are added at checkout.</p>
          <a class="vfn-btn vfn-cart__checkout" href="${R().checkout}">Checkout <span aria-hidden="true">→</span></a>
          <button type="button" class="vfn-cart__keep">Keep browsing</button>
        </div>
      </div>`;
    document.body.appendChild(drawer);
    listEl = drawer.querySelector('.vfn-cart__list'); totalEl = drawer.querySelector('.vfn-cart__total strong');
    msgEl = drawer.querySelector('.vfn-cart__msg'); checkoutBtn = drawer.querySelector('.vfn-cart__checkout');
    drawer.querySelector('.vfn-cart__close').addEventListener('click', close);
    drawer.querySelector('.vfn-cart__keep').addEventListener('click', close);
    drawer.addEventListener('click', e => { if (e.target === drawer) close(); });
    drawer.addEventListener('close', () => document.documentElement.classList.remove('vfn-cart-open'));
    listEl.addEventListener('click', e => {
      const b = e.target.closest('[data-qty]'); if (!b || busy) return;
      const li = b.closest('[data-key]'); const q = Math.max(0, Number(li.dataset.qty) + Number(b.dataset.qty));
      update(li.dataset.key, b.dataset.qty === 'remove' ? 0 : q);
    });
  }
  function open() { build(); if (!drawer.open) { drawer.showModal ? drawer.showModal() : drawer.setAttribute('open', ''); } document.documentElement.classList.add('vfn-cart-open'); }
  function close() { if (!drawer) return; drawer.classList.add('is-closing'); setTimeout(() => { drawer.classList.remove('is-closing'); drawer.close ? drawer.close() : drawer.removeAttribute('open'); }, 220); }
  function setCount(n) {
    document.querySelectorAll('[data-vfn-cart-count]').forEach(el => (el.textContent = n));
    document.querySelectorAll('[data-vfn-cart-link]').forEach(el => (el.hidden = !n));
  }
  function render(cart) {
    setCount(cart.item_count);
    if (!cart.items.length) {
      listEl.innerHTML = '<li class="vfn-cart__empty">Your cart is empty.</li>';
      checkoutBtn.hidden = true; drawer.querySelector('.vfn-cart__total').hidden = true; return;
    }
    checkoutBtn.hidden = false; drawer.querySelector('.vfn-cart__total').hidden = false;
    listEl.innerHTML = cart.items.map(it => `
      <li class="vfn-cart__item" data-key="${esc(it.key)}" data-qty="${it.quantity}">
        ${(window.vfnCartIcons || {})[it.handle] ? `<span class="vfn-cart__img vfn-cart__img--icon" aria-hidden="true"><img src="${esc(window.vfnCartIcons[it.handle])}" alt="" width="44" height="44"></span>`
          : it.image ? `<img class="vfn-cart__img" src="${esc(it.image)}${it.image.includes('?') ? '&' : '?'}width=160" alt="" width="64" height="64">` : '<span class="vfn-cart__img" aria-hidden="true"></span>'}
        <div class="vfn-cart__info">
          <p class="vfn-cart__name">${esc(it.product_title)}</p>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<p class="vfn-cart__variant">${esc(it.variant_title)}</p>` : ''}
          <div class="vfn-cart__qty" aria-label="Quantity">
            <button type="button" data-qty="-1" aria-label="One fewer ${esc(it.product_title)}">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-qty="1" aria-label="One more ${esc(it.product_title)}">+</button>
            <button type="button" class="vfn-cart__remove" data-qty="remove">Remove</button>
          </div>
        </div>
        <p class="vfn-cart__price">${money(it.final_line_price, cart.currency)}</p>
      </li>`).join('');
    totalEl.textContent = money(cart.total_price, cart.currency);
  }
  function say(t) { if (msgEl) msgEl.textContent = t || ''; }
  async function update(key, qty) {
    busy = true; drawer.classList.add('is-busy'); say('');
    try { render(await api.change(key, qty)); } catch (e) { say(e.message); }
    busy = false; drawer.classList.remove('is-busy');
  }
  async function addFromForm(form, btn) {
    const id = form.querySelector('[name="id"]')?.value; if (!id) return;
    const qty = Number(form.querySelector('[name="quantity"]')?.value || 1);
    btn && (btn.disabled = true, btn.classList.add('is-adding'));
    build(); open(); say('Adding…'); drawer.classList.add('is-busy');
    try { await api.add(id, qty); render(await api.get()); say('Added to your cart.'); }
    catch (e) { try { render(await api.get()); } catch (_) {} say(e.message); }
    drawer.classList.remove('is-busy');
    btn && (btn.disabled = false, btn.classList.remove('is-adding'));
  }
  document.addEventListener('submit', e => {
    const wrap = e.target.closest('[data-vfn-buy]'); if (!wrap) return;
    e.preventDefault(); e.stopPropagation();
    addFromForm(e.target, e.submitter || e.target.querySelector('[type="submit"]'));
  }, true);
  document.addEventListener('click', async e => {
    const a = e.target.closest('[data-vfn-cart-open]'); if (!a) return;
    e.preventDefault(); build(); open(); drawer.classList.add('is-busy');
    try { render(await api.get()); } catch (err) { say('Could not load your cart. Please refresh and try again.'); }
    drawer.classList.remove('is-busy');
  });
  window.addEventListener('pageshow', ev => { if (ev.persisted) api.get().then(c => setCount(c.item_count)).catch(() => {}); });
})();
